// ─── Weapon Classes ──────────────────────────────────────────────────
export type WeaponClass = 'cutlass' | 'flintlock' | 'musket' | 'boarding_axe' | 'harpoon'
export type WeaponCategory = 'melee' | 'ranged' | 'thrown'

export type AbilityType = 'dodge_roll' | 'block' | 'power_strike' | 'quick_reload' | 'steady_aim'

export interface WeaponInfo {
  class: WeaponClass
  name: string
  category: WeaponCategory
  description: string
  damage: number
  attackSpeed: number    // attacks per second
  range: number          // units (melee reach or max projectile range)
  projectileSpeed?: number
  reloadTime?: number    // seconds (ranged only)
  price: number          // follis
  ability: AbilityType
  abilityDescription: string
  abilityCooldown: number // seconds
  // Visual
  color: [number, number, number]
  accentColor: [number, number, number]
}

export const WEAPONS: Record<WeaponClass, WeaponInfo> = {
  cutlass: {
    class: 'cutlass',
    name: 'Cutlass',
    category: 'melee',
    description: 'A swift naval sword. Fast attacks, short reach.',
    damage: 15,
    attackSpeed: 4.0,
    range: 5,
    price: 0,
    ability: 'dodge_roll',
    abilityDescription: 'Dodge Roll — dash in your movement direction, briefly invulnerable.',
    abilityCooldown: 1.5,
    color: [0.7, 0.72, 0.74],
    accentColor: [0.45, 0.30, 0.15],
  },
  boarding_axe: {
    class: 'boarding_axe',
    name: 'Boarding Axe',
    category: 'melee',
    description: 'A brutal chopping weapon. Slow but devastating.',
    damage: 35,
    attackSpeed: 2.5,
    range: 4,
    price: 120,
    ability: 'power_strike',
    abilityDescription: 'Power Strike — charge a heavy blow that deals 3x damage.',
    abilityCooldown: 4,
    color: [0.5, 0.5, 0.52],
    accentColor: [0.55, 0.35, 0.18],
  },
  flintlock: {
    class: 'flintlock',
    name: 'Flintlock Pistol',
    category: 'ranged',
    description: 'A single-shot pistol. Quick to draw, slow to reload.',
    damage: 25,
    attackSpeed: 1.5,
    range: 60,
    projectileSpeed: 200,
    reloadTime: 0.8,
    price: 200,
    ability: 'quick_reload',
    abilityDescription: 'Quick Reload — instantly reload and fire again.',
    abilityCooldown: 5,
    color: [0.35, 0.28, 0.18],
    accentColor: [0.6, 0.6, 0.62],
  },
  musket: {
    class: 'musket',
    name: 'Musket',
    category: 'ranged',
    description: 'A long-barreled firearm. High damage at extreme range.',
    damage: 50,
    attackSpeed: 1.0,
    range: 120,
    projectileSpeed: 300,
    reloadTime: 1.2,
    price: 500,
    ability: 'steady_aim',
    abilityDescription: 'Steady Aim — next shot deals 2x damage with perfect accuracy.',
    abilityCooldown: 6,
    color: [0.40, 0.32, 0.20],
    accentColor: [0.55, 0.55, 0.58],
  },
  harpoon: {
    class: 'harpoon',
    name: 'Harpoon',
    category: 'thrown',
    description: 'A throwable spear. Medium range, retrieves on hit.',
    damage: 30,
    attackSpeed: 2.0,
    range: 40,
    projectileSpeed: 150,
    reloadTime: 0.6,
    price: 80,
    ability: 'block',
    abilityDescription: 'Block — brace the harpoon to deflect incoming attacks.',
    abilityCooldown: 0.5,
    color: [0.55, 0.45, 0.30],
    accentColor: [0.4, 0.4, 0.42],
  },
}

export const WEAPON_ORDER: WeaponClass[] = ['cutlass', 'boarding_axe', 'flintlock', 'musket', 'harpoon']

export const WEAPON_SLOT_KEYS = ['1', '2', '3', '4', '5'] as const
